import { useIsAuctionAdmin, getIsAuctionAdmin } from './useIsAuctionAdmin'
import { useIsGlobalAdmin, getIsGlobalAdmin } from './useIsGlobalAdmin'

/** Is Global (Auction EDGE) admin or (currently active) auction admin */
export const useIsAdmin = (props?: { skip?: boolean }) => {
    const { skip } = props || {}
    const isEdgeAdmin = useIsGlobalAdmin({ skip })
    const isAuctionAdmin = useIsAuctionAdmin({ skip: skip || isEdgeAdmin })
    const isAdmin = isEdgeAdmin || isAuctionAdmin
    return isAdmin
}

/** Is Global (Auction EDGE) admin or (currently active) auction admin */
export const getIsAdmin = async () => {
    const isEdgeAdmin = await getIsGlobalAdmin()
    if (isEdgeAdmin) {
        return true
    }

    const isAuctionAdmin = await getIsAuctionAdmin()
    if (isAuctionAdmin) {
        return true
    }

    return false
}
